import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { appBar, transitions, zIndex } from '@twistopayments/design-system/styles';

export const root = (theme: Theme) => css`
  padding: ${theme.spacing[8]} ${theme.spacing[16]};
  padding-right: ${theme.spacing[24]};

  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  min-height: ${appBar.minHeight};
`;

export const content = (theme: Theme) => css`
  flex-grow: 1;
  margin: 0 ${theme.spacing[16]};
`;

export const variants = {
  contained: (theme: Theme) => css`
    background: ${theme.palette.background.main};
  `,
  fixed: (theme: Theme) => css`
    top: 0;
    left: 0;
    right: 0;
    position: fixed;
    padding-right: ${theme.spacing[24]};
    background: ${theme.palette.background.main};
    transition: box-shadow ${transitions.default};
    z-index: ${zIndex.appBar};
  `,
  light: () => css`
    background: none;
  `,
};

export const shadow = (theme: Theme) => css`
  box-shadow: ${theme.shadows.box};
`;

export const actions = css`
  display: flex;
`;

export const positions = {
  left: css`
    margin-right: auto;
  `,
  right: css`
    margin-left: auto;
  `,
  center: css`
    margin-left: auto;
    margin-right: auto;
  `,
};

export const centered = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
`;
